import { useTranslation } from "react-i18next";
import { ErrorResponse, useCustomToast } from "features/auth/hooks/use-custom-toast/use-custom-toast";
import { useToast } from "hooks/use-toast";
import { useConfig } from "hooks/use-config";
import { useGlobalMutation } from "state/query-client/hooks";
import { contactSales } from "./subscription-service";


export const useContactSales = () => {
    const { showErrorToast } = useCustomToast();
    const { toast } = useToast();
    const { t } = useTranslation();
    const { configurationSettings } = useConfig();


    interface ContactFormData {
        language: string;
        message: string;
        organizationName: string;
        contactName: string;
        phone: string | undefined;
        emailTo: string;
        email: string;
    }

    return useGlobalMutation({
        mutationKey: ['contactSales'],
        mutationFn: (payload: ContactFormData) => contactSales({ ...payload }, configurationSettings),

        onSuccess: () => {
            toast({
                variant: 'success',
                title: t('SUCCESS'),
                description: "Message sent successfully",
            });
        },
        onError: ({ error }: ErrorResponse) => {
            showErrorToast(error);
        },
    });
};